/**
 * The cards to fly for one move of a replay, from its log entry: each card that went from one place to another, as
 * [owner, from, to, cardId or null for face down]. Places are the log's (hand, deck, discard, prize, active, bench:N).
 */
export function replayFlights(entry) {
  // Moving benched Pokémon around is a note, not a card move (the server calls it tidying): they slide, both ways.
  const arranged = (entry.notes || []).filter(note => note.kind === 'arranged').flatMap(note => [
    [note.owner, `bench:${note.from}`, `bench:${note.to}`, note.card],
    ...(note.swapped ? [[note.owner, `bench:${note.to}`, `bench:${note.from}`, note.swapped]] : []),
  ]);
  return arranged.concat((entry.cards || []).flatMap((move) => {
    if (!move.from || !move.to) {
      return [];
    }
    const ids = move.cards || Array.from({ length: Math.min(move.count || 0, 6) }, () => null);
    // A Pokémon moving takes its cards along: one card flies for it, the Pokémon on top (the first is enough).
    const going = move.from.startsWith('bench:') || move.from === 'active' ? ids.slice(0, 1) : ids;
    return going.map(id => [move.owner, move.from, move.to, id]);
  }));
}

/**
 * Where a card is on screen for a flight, as a selector: a spot on the mat (the side is "player" for the viewer's
 * own), one card in your replay hand (by card id), or the opponent's hand past the far edge of the mat.
 */
export function placeSelector(place, mine, owner, cardId = null) {
  const side = `[data-side="${mine ? 'player' : 'opponent'}"]`;
  if (place === 'hand') {
    if (!mine) {
      return '[data-replay-opponent-hand]';
    }
    return cardId ? `[data-replay-hand] [data-card-id="${cardId}"]` : null;
  }
  if (place.startsWith('bench:')) {
    return `${side} [data-zone="bench"][data-position="${place.slice('bench:'.length)}"]`;
  }
  return `${side} [data-zone="${place}"]`;
}
